import type { JobMeta } from '../types';

export const meta: JobMeta = {
  slug: 'founding-marketing-lead',
  title: 'Founding Marketing Lead',
  location: 'Remote (US & New York City-based preferred)',
  applyEmail: 'jobs@getcartwheel.com',
  aboutCompany:
    "Cartwheel is revolutionizing the 3D animation industry with our generative animation platform. Our tool empowers creators to animate characters for videos, games, movies, advertisements, social media, or VR simply by typing commands, recording themselves or using reference video, or choosing from the world's largest motion library. This approach makes 3D animation more accessible, efficient, and fun for professional animators, creators, or anyone that wants to get creative.",
  roleDescription:
    'As Cartwheel\'s inaugural marketing lead, you will be instrumental in introducing our groundbreaking platform to the world. This role requires an experienced, strategic, and hands-on marketer capable of developing and executing campaigns that drive awareness, adoption, and engagement among our target audiences from concept through execution.',
  closingComment:
    "If you're passionate about making a significant impact and helping to drive the success of a groundbreaking tool, we'd love to hear from you!",
  whatYoullDo: [
    <>
      <strong>Develop and Implement Marketing Strategy:</strong> Craft and
      execute a comprehensive marketing plan to drive brand awareness and user
      acquisition across various creative industries. You will own this side of
      our business, bringing new strategies and best practices to the company.
    </>,
    <>
      <strong>Content Creation:</strong> Produce compelling content, including
      blog posts, tutorials, case studies, and social media updates, to educate
      potential users about the benefits and applications of our platform.
    </>,
    <>
      <strong>Digital Marketing:</strong> Manage and optimize digital campaigns
      across channels such as email, social media, and search engines to attract
      and engage users.
    </>,
    <>
      <strong>Community Building:</strong> Foster and grow a community of
      creators, animators, and enthusiasts through engagement initiatives,
      forums, and events.
    </>,
    <>
      <strong>Partnerships:</strong> Identify and establish partnerships with
      industry influencers, educational institutions, and creative organizations
      to expand our reach.
    </>,
    <>
      <strong>Analytics and Reporting:</strong> Monitor and analyze marketing
      performance metrics, providing regular reports and insights to inform
      strategy adjustments.
    </>,
  ],
  whoYouAre: [
    <>
      <strong>5+ years of experience in marketing</strong>, preferably in a
      startup or tech environment.
    </>,
    <>
      Experience in <strong>B2C or prosumer marketing</strong>, ideally
      targeting creative professionals (e.g., animators, game designers, content
      creators).
    </>,
    <>
      Strong <strong>storytelling and content marketing skills</strong>, with
      the ability to communicate complex concepts in an accessible and engaging
      way.
    </>,
    <>
      Hands-on experience in <strong>performance marketing</strong>, including
      paid social, SEO, email marketing, and conversion optimization.
    </>,
    <>
      Familiarity with <strong>digital marketing tools and platforms</strong>,
      including CRM systems, email marketing, and analytics tools.
    </>,
    <>
      Experience <strong>building and engaging communities</strong>, with a deep
      understanding of platforms like Twitter, Discord, Reddit, and LinkedIn,
      while also developing offline networks with educators and other sectors.
    </>,
    <>
      Strong <strong>analytical mindset</strong>, comfortable setting KPIs,
      analyzing performance data, and using insights to optimize campaigns.
    </>,
    <>
      Ability to <strong>execute across multiple channels</strong> while
      thinking strategically about long-term brand positioning and growth.
    </>,
    <>
      A <strong>builder mentality</strong> with a bias for action. You are a
      self-starter who is comfortable working independently and making
      data-driven decisions.
    </>,
    <>
      <strong>Passion for animation, gaming, or creative tools</strong> is a big
      plus!
    </>,
  ],
  whyJoinUs: [
    <>
      <strong>Impact:</strong> Play a pivotal role in shaping the future of 3D
      animation technology through groundbreaking AI research.
    </>,
    <>
      <strong>Growth:</strong> Opportunity to grow with the company, with
      potential for increased responsibilities and leadership roles.
    </>,
    <>
      <strong>Culture:</strong> Join a collaborative and innovative team that
      values initiative, creativity, and diversity.
    </>,
    <>
      <strong>Mission:</strong> Contribute to a mission-driven organization
      dedicated to making animation more accessible for creative people
      worldwide.
    </>,
  ],
};
